import React from 'react';
import compose from '../../../hoc/compose';
import displayNames from '../../displayNames';

var RoundedIllustrationContainer = function RoundedIllustrationContainer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('rounded-illustration-container')
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-illustration-icon-content"
  }, props.children));
};

RoundedIllustrationContainer.propTypes = {};
RoundedIllustrationContainer.DisplayName = displayNames.ROUNDED_ILLUSTRATION_CONTAINER;
export default compose(RoundedIllustrationContainer);